import { jwtDecode } from 'jwt-decode';
import { mainLogger } from '../logger';
const logger = mainLogger.createChild('decodeToken');
export function decodeToken(token) {
  if (!token) {
    return null;
  }
  try {
    return jwtDecode(token);
  } catch (error) {
    logger.error(new Error('Error happened during token decode', {
      cause: error
    }));
    return null;
  }
}
//# sourceMappingURL=decodeToken.js.map